export default function multimediaTransform(
  multimedia: {
    filename: string;
    id: string;
    translations: { locale: string; title: string; description: string }[];
    url: string;
  }[]
) {
  return multimedia.map((it: any) =>
    Object.assign(new File([""], it.filename), {
      preview: it.url,
      translations:
        (it.translations &&
          it.translations.reduce(
            (
              accum: { key: { title: string; description: string } },
              curr: { locale: string; title: string; description: string }
            ) => {
              const locale = curr.locale;
              return {
                ...accum,
                [locale]: {
                  title: curr.title,
                  description: curr.description,
                },
              };
            },
            {}
          )) ||
        {},
      id: it.id,
      modifiedName: it.filename,
    })
  );
}